<template>
  <div class="zwx-scrollbar-x">
    <el-scrollbar class="zwx-scrollbar-box-x">
      <slot />
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'ZwxScrollbarX',
}
</script>

<style lang="less" scoped></style>

<style lang="less">
.zwx-scrollbar-x .zwx-scrollbar-box-x {
  white-space: nowrap !important;
}

.zwx-scrollbar-x .zwx-scrollbar-box-x .el-scrollbar__wrap {
  overflow: scroll !important;
  margin-right: 0 !important;
}

.zwx-scrollbar-x .zwx-scrollbar-box-x .el-scrollbar__bar.is-horizontal {
  height: 8px !important;
  pointer-events: none !important;
}

.zwx-scrollbar-x .zwx-scrollbar-box-x > .el-scrollbar__bar.is-vertical {
  display: none !important;
  pointer-events: none !important;
}

.zwx-scrollbar-x .zwx-scrollbar-box-x .el-scrollbar__thumb {
  border-radius: 3px !important;
  background-color: #d8d8d8 !important;
  cursor: default !important;
  pointer-events: auto !important;
}

.zwx-scrollbar-x .zwx-scrollbar-box-x .el-scrollbar__thumb:hover,
.zwx-scrollbar-x .zwx-scrollbar-box-x .el-scrollbar__thumb:active {
  background-color: #b3b3b3 !important;
}
</style>
